import { render, staticRenderFns } from "./bussetting-selectdata.vue?vue&type=template&id=b45f5450&scoped=true&"
import script from "./bussetting-selectdata.vue?vue&type=script&lang=js&"
export * from "./bussetting-selectdata.vue?vue&type=script&lang=js&"
import style0 from "./bussetting-selectdata.vue?vue&type=style&index=0&id=b45f5450&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45f5450",
  null
  
)

export default component.exports